import React from 'react';
import Footer from './Footer';
import CookieBanner from '../Layout/CookieBanner';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
  <div className="flex flex-col min-h-screen bg-white">
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
    <CookieBanner /> 
  </div>

  );
};

export default Layout;